import React from 'react';
import '@spotify-internal/encore-web/css/encore-creator-dark-theme.css';
import '@spotify-internal/encore-web/css/encore-creator-light-theme.css';
import '@spotify-internal/encore-web/css/fonts.css';
// to support previous encore versions without fonts.css file

import { ButtonPrimary, Type, spacer24 } from '@spotify-internal/encore-web';

import styled from 'styled-components';
import { useUser, LoginState } from '../helpers/user/useUser';
import { LoadingPage } from './LoadingPage';
import { RemoteConfig } from '../helpers/remoteConfig/RemoteConfig';
import { ErrorBoundaryProvider } from '../components/ErrorBoundary';
import Head from 'next/head';
import {
  GlobalStyles,
  KeyboardDetectionProvider,
} from '@spotify-internal/encore-web';
import { useT } from '@spotify-internal/i18n-core';
import { useRouter } from 'next/router';
import { HeaderlessLayout } from './Chrome/HeaderlessLayout';

const Container = styled.main`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
  flex: 1;
`;

export const Layout = ({ children }: React.PropsWithChildren<{}>) => {
  const { loginState, login } = useUser();
  const translate = useT();
  const { pathname } = useRouter();

  const unauthedPath = pathname === '/unauthorized';

  return (
    <React.Fragment>
      <Head>
        <link rel="shortcut icon" href="/favicon.ico?v=1" />
        <title>Spotify for Music Providers</title>
      </Head>
      <GlobalStyles />
      <ErrorBoundaryProvider>
        <KeyboardDetectionProvider>
          <Container className="encore-creator-light-theme">
            {loginState === LoginState.AWAITING_LOGIN && <LoadingPage />}
            {loginState === LoginState.LOGGEDIN && !unauthedPath && (
              <RemoteConfig>{children}</RemoteConfig>
            )}
            {loginState === LoginState.LOGIN_FAILED && (
              <HeaderlessLayout className="encore-creator-light-theme">
                <Type as="p" variant="altoBrio" paddingBottom={spacer24}>
                  {translate(
                    'S4MP_LOGIN_FAILED',
                    'Login failed.',
                    'Short message letting user know login to s4mp failed somehow',
                  )}
                </Type>
                <ButtonPrimary onClick={login}>
                  {translate(
                    'S4MP_LOGIN_RETRY',
                    'Retry',
                    'Button that will allow users to retry login after login fails',
                  )}
                </ButtonPrimary>
              </HeaderlessLayout>
            )}
            {unauthedPath && (
              <HeaderlessLayout className="encore-creator-dark-theme">
                {children}
              </HeaderlessLayout>
            )}
          </Container>
        </KeyboardDetectionProvider>
      </ErrorBoundaryProvider>
    </React.Fragment>
  );
};

export default Layout;
